import { isNil } from 'lodash'
import { time2Pixel } from '~/Util'

// Calculating the X coordinate of a dragged block
export const setDraggableBlockLeftX = ({
  dragItem,
  historyX,
  draggableBlockStartTime,
  leftXOffset,
  intersectionPlaceholder,
  insertBetween,
  scale,
  draggableBlockLeftX,
  initialLayerIndex,
  isOverlapped,
  overNewLayerIndex,
  transitionOffset,
  isExternalSource,
}) => {
  let finalDraggableBlockLeftX = draggableBlockLeftX + transitionOffset
  let dropOffsetX = 0

  if (draggableBlockStartTime <= 0) {
    finalDraggableBlockLeftX = leftXOffset
  } else if (isNil(overNewLayerIndex)) {
    if (intersectionPlaceholder || insertBetween) {
      const startTime = dragItem.selectedAssetsByLayerIndex?.[initialLayerIndex]?.[0]?.startTime
      const deltaBetweenAssets = isExternalSource ? 0 : dragItem.startTime - startTime
      dropOffsetX = time2Pixel(deltaBetweenAssets, scale)
    } else if (draggableBlockStartTime >= 0 && isOverlapped && historyX.current.isMountedOnLayer) {
      finalDraggableBlockLeftX = historyX.current.stopDragLeftX
    }
  }

  return { finalDraggableBlockLeftX, dropOffsetX }
}
